module.exports = __webpack_public_path__ + "static/media/boomers_bookParty.7cd2ab17.svg";